import {NextPage} from "next";
import {ChangeSubscriptionTemplate} from "../../components/templates/changeSubscriptionTemplate";
import { useState } from "react";
import {BackendClient} from "../../utils/backendClient";

interface pageProps {}

const Page: NextPage<pageProps> = () => {
    const [loading, setLoading] = useState<boolean>(false)

    const sentChangeEmail = async (email: string) => {
        setLoading(true);
        const res = await BackendClient.changeControllerChangeEmail({changeEmail: {email: email}});
        setLoading(false);
    }

    return (
        <ChangeSubscriptionTemplate handleSubmit={sentChangeEmail} update={loading}/>
    )
}

export default Page;
